import { render, staticRenderFns } from "./createdatapush.vue?vue&type=template&id=4ada643a&"
import script from "./createdatapush.vue?vue&type=script&lang=ts&"
export * from "./createdatapush.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "createdatapush.vue"
export default component.exports